import axios from '../../axios';

export type ServiceResponse = {
  id: string;
  caseNumber: string;
  webCategory: string;
  supplierName: string;
  supplierPhone: string;
  appointmentDate: string;
  recordType: string;
  status: string;
  appointmentStatus: string;
  address: string;
  lat: string;
  lon: string;
  plateNumber: string;
  serviceName: string;
  contactName: string;
  contactMail: string;
  nameSurname: string;
  receiverPersonName: string;
  receiverPersonPhone: string;
  receiverPersonTC: string;
  numberPlate: number;
  deliveryPersonName: string;
  deliveryPersonPhone: string;
  deliveryAddress: string;
  impoundCarReason: string;
  ogsHgsType: string;
  trafficBranchName: string;
  trafficBranchPhone: string;
  carParkName: string;
  carParkPhone: string;
  km: number;
  city: string;
  travelStartDate: string;
  travelEndDate: string;
  destinationCountries: string;
  impoundCarReasonEnum: ImpoundCarReasonEnum;
  ogsHgsTypeEnum: OgsHgsTypeEnum;
  appointmentStatusEnum: AppointmentStatusEnum;
  statusEnum: StatusEnum;
  webCategoryEnum: WebCategoryEnum;
}
type ImpoundCarReasonEnum = 'USE_OF_ALCOHOL' | 'MISSING_DOCUMENT' | 'FAULTY_PARKING' | 'INJURY' | 'OTHER' | 'NONE';
type OgsHgsTypeEnum = 'FAILURE' | 'USAGE_DETAILS' | 'NEW_DEMAND' | 'NONE';
type AppointmentStatusEnum = 'NONE' | 'APPOINTMENT_REQUESTED' | 'APPOINTMENT_APPROVED';
type StatusEnum =
  'SOLVED'
  | 'CLOSED'
  | 'CANCELLED'
  | 'NEW'
  | 'WORK_IN_PROGRESS'
  | 'WAITING_FOR_INFORMATION'
  | 'OWNED'
  | 'OTHER';
type WebCategoryEnum =
  'FAILURE'
  | 'DAMAGE'
  | 'TIRE'
  | 'MAINTENANCE'
  | 'INVOICE_OBJECTION'
  | 'LOGO'
  | 'PENALTY_INVOICE'
  | 'TRAFFIC_POLICY'
  | 'VEHICLE_RETURN'
  | 'OGS_HGS'
  | 'OCCUPIED_VEHICLE'
  | 'MISSING_LICENSE'
  | 'MISSING_PLATE'
  | 'VEHICLE_INSPECTION'
  | 'FOREIGN_EXIT'
  | 'OTHER';

export type ServiceRequest = {
  isTask?: boolean;
  recordType?: "MAINTENANCE" | "DAMAGE" | "FAILURE" | "TIRE" | "ALL";
  status?: "NEW" | "WORK_IN_PROGRESS" | "SOLVED" | "CLOSED" | "CANCELLED" | "WAITING_FOR_INFORMATION" | "OTHER";
  statusNot?: "NEW" | "WORK_IN_PROGRESS" | "SOLVED" | "CLOSED" | "CANCELLED" | "WAITING_FOR_INFORMATION" | "OTHER";
  appointmentStatus?: "NONE" | "APPOINTMENT_REQUESTED" | "APPOINTMENT_APPROVED";
  startDate?: string;
  endDate?: string;
}
export default async function getServicesRepository(params: ServiceRequest): Promise<ServiceResponse[]> {
  let res = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/case`,
    {
      params,
    },
  );
  return res.data;
}